<template>
    <p>
        {{ date }}
    </p>
    <p>
        {{ userStore.user.firstname }} {{ userStore.user.lastname }}
        <br />{{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
    </p>
    <p>
        {{ creditBureau.address_name }} <br />
        {{ address.street }} <br />
        {{ address.city }}, {{ address.state_abbreviation }} {{ address.zipcode }}
    </p>
    <div class="page">
        <p class="letter-content">
            I was looking over my credit report recently and found a bankruptcy and am requesting you verify the accuracy of this
            entry. If verification is not possible, the entry must be removed immediately.
            <br>
            <template v-for="publicRecord in reportStore.getSelectedAccounts(1, creditBureau.id, 'public-record')">
                <strong>"{{ publicRecord.type }}"</strong>with<strong> Reference#: {{ publicRecord.reference_number }}</strong>.
                <br />
            </template>
        </p>
        <p>
            Please respond to me in writing and include the “method of verification” under FCRA 611 (a)(7). This should include the
            following:
        </p>
        <p>
            <ol>
                <li>The name of the courthouse with which you verified the information</li>
                <li>The name of the person at the courthouse who handled your request</li>
                <li>The address of the courthouse</li>
                <li>Which document you obtained to verify the bankruptcy</li>
            </ol>
        </p>
        <p>
            Enclosed is a copy of ID and bankruptcy Validation Letter.
        </p>
        <p style="page-break-after: always;">
            Sincerely, <br> <br>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../stores/ReportStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
